import {ApiError} from 'shared/web';

interface DataWithErrors {
  errors?: {
    code?: string | null;
  }[];
}

export const is409UserDeactivatedError = (error: ApiError): boolean => {
  if (!('data' in error)) {
    return false;
  }
  const is409Status = error?.status === 409;
  const data = error?.data as DataWithErrors;
  const isDeactivatedErrorCode =
    data.errors?.some((error) => error?.code === 'DMS-CO-US-0009') || false;

  return is409Status && isDeactivatedErrorCode;
};
